// @flow

import React from 'react'

import { AttributeAutocompleteInput } from '../../../../Attributes/AttributeAutocompleteInput/AttributeAutocompleteInput'

type Props = {
  value: string,
  onChange: Function
}

export function MessageItemTitle ({ value, onChange }: Props) {
  return (
    <>
      <div className="cc-modal__field__label">
        Title
      </div>
      <div className="cc-modal__field__body">
        <AttributeAutocompleteInput
          autoFocus
          isInputStyle
          placeholder="Set Title (Required 80 chars max)"
          value={value}
          maxLength={80}
          onBlur={onChange}
          onPressEnterKey={onChange}
        />
      </div>
    </>
  )
}
